import useAuth from '../HOCs/auth/useAuth';

const useIsAdmin = () => {
  const { isLoggedInFromApi, isGoogleAuthenticated } = useAuth();
  return isLoggedInFromApi && isGoogleAuthenticated;
};

export default useIsAdmin;
